// type Environment = "development" | "production";

// const endpoints: Record<Environment, string> = {
//   development: "https://eigen-development.fly.dev",
//   production: "https://eigen-production.fly.dev",
// };
// console.log(
//   "import.meta.env.VITE_ENVIRONMENT",
//   import.meta.env.VITE_ENVIRONMENT
// );
import { resolvePostMessageAllowedOrigins } from "./postMessageOrigins";

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

// export const POCKETBASE_BASE_ENDPOINT = endpoints[ENVIRONMENT];
export const POCKETBASE_BASE_ENDPOINT = import.meta.env.VITE_POCKETBASE_ENDPOINT;

// EADP-2: the build-selected INTERNAL driver (login + app-definitions source). Defaults to
// "PocketBase" -> the runtime authenticates + loads app-defs from prod pb.dataroot.cl, exactly
// as before (client.dataroot.cl is unaffected). The eigenapps.eigenify.com DEMO build sets
// VITE_INTERNAL_DRIVER_TYPE=Postgres + VITE_INTERNAL_ENDPOINT=<EADP-1 demo-driver origin> so
// demos load login + app-defs from the ISOLATED demo Postgres, never touching prod PB.
// NOTE: a non-default value REQUIRES that driver to be registered (registerInternalDriver) in
// plugins.ts BEFORE Core is constructed; "PocketBase" is registered statically and is the only
// value safe without the @data-root/plugin-data-provider-postgres dep present.
export const INTERNAL_DRIVER_TYPE =
  import.meta.env.VITE_INTERNAL_DRIVER_TYPE || "PocketBase";

// The endpoint the internal driver talks to. For PocketBase this is the PB URL; for the demo
// Postgres driver this is the EADP-1 demo-driver server origin. Defaults to the PB endpoint so
// the existing build is unchanged.
export const INTERNAL_ENDPOINT =
  import.meta.env.VITE_INTERNAL_ENDPOINT || POCKETBASE_BASE_ENDPOINT;

export const USE_SENTRY = (import.meta.env.VITE_USE_SENTRY ?? "0") === "1";

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000";

// Origins that must ALWAYS be allowed to embed/postMessage with the runtime (the
// Eigenify runtime is the parent frame for embedded EigenApps; #44 eigenify.com
// convergence). "https://*.eigenify.com" is a subdomain wildcard understood by
// isOriginAllowed (see postMessageOrigins.ts).
const EIGENIFY_POSTMESSAGE_ORIGINS = [
  "https://eigenify.com",
  "https://app.eigenify.com",
  "https://eigenapps.eigenify.com",
  "https://*.eigenify.com",
  // EigenAdvisor is a parent frame for the no-login demo preview (DR-EMBED REFRESH_RESULT
  // handshake). advisor.eigenify.com is already covered by the *.eigenify.com wildcard; the
  // dataroot.cl host is the current prod domain, so it must be allowlisted explicitly or the
  // SPA silently drops the parent's REFRESH_RESULT and the preview falls back to the login view.
  "https://advisor.dataroot.cl",
];

// SECURITY (Lane Q7, audit F3): no wildcard default, ever. Dev defaults to the known
// local parents; production FAILS CLOSED (empty) when unset; an explicit "*" is
// rejected. The eigenify.com origins are unioned on top so tightening the default away
// from "*" does not regress the eigenify.com embedding (#44).
export const POSTMESSAGE_ALLOWED_ORIGINS: string[] = Array.from(
  new Set([
    ...resolvePostMessageAllowedOrigins(
      import.meta.env.VITE_POSTMESSAGE_ALLOWED_ORIGINS,
      import.meta.env.DEV
    ),
    ...EIGENIFY_POSTMESSAGE_ORIGINS,
  ]),
);

const DEFAULT_AUTH_REFRESH_MARGIN_MS = 30 * 1000;
export const AUTH_REFRESH_MARGIN_MS = import.meta.env.VITE_AUTH_REFRESH_MARGIN_MS
  ? parseInt(import.meta.env.VITE_AUTH_REFRESH_MARGIN_MS, 10)
  : DEFAULT_AUTH_REFRESH_MARGIN_MS;

export const AUTH_EMBED_MODE_KEY =
  import.meta.env.VITE_AUTH_EMBED_MODE_KEY ?? "eigen_embed_mode";

console.log("GIT_HASH", __GIT_HASH__);

console.log("POCKETBASE_BASE_ENDPOINT", POCKETBASE_BASE_ENDPOINT);
